import { MetricCardINR } from '../ui/MetricCard';
import { formatINRCompact } from '../../utils/formatters';

export function KPICards({ metrics }) {
  if (!metrics) return null;

  const runway =
    metrics.runwayMonths != null
      ? `${metrics.runwayMonths} mo`
      : '—';

  return (
    <div className="-mx-1 overflow-x-auto pb-1 md:mx-0 md:overflow-visible md:pb-0">
      <div className="grid min-w-[720px] grid-cols-2 gap-3 md:min-w-0 md:grid-cols-4 xl:grid-cols-4">
      <MetricCardINR
        label="Net profit"
        amount={metrics.netProfit}
        changePct={metrics.netProfitChangePct}
      />
      <MetricCardINR label="Revenue" amount={metrics.revenue} changePct={metrics.revenueChangePct} />
      <MetricCardINR
        label="Expenses"
        amount={metrics.expenses}
        changePct={metrics.expensesChangePct}
        isInverse
      />
      <MetricCardINR label="Cash balance" amount={metrics.cashBalance} changePct={metrics.cashChangePct} />
      <MetricCardINR label="Receivables" amount={metrics.receivables} />
      <MetricCardINR label="Payables" amount={metrics.payables} />
      <div className="rounded-xl border border-slate-200/80 bg-white p-4 shadow-sm">
        <p className="text-xs font-medium uppercase tracking-wide text-slate-500">Burn rate (avg / mo)</p>
        <p className="mt-1 text-2xl font-bold text-slate-900">{formatINRCompact(metrics.burnRate)}</p>
      </div>
      <div className="rounded-xl border border-slate-200/80 bg-white p-4 shadow-sm">
        <p className="text-xs font-medium uppercase tracking-wide text-slate-500">Runway</p>
        <p className="mt-1 text-2xl font-bold text-slate-900">{runway}</p>
      </div>
      </div>
    </div>
  );
}
